import { Controller } from "@hotwired/stimulus"
import * as bootstrap from 'bootstrap'

export default class extends Controller {
  static targets = ["form"]
  static values = {
    currentAdminTotpEnabled: Boolean
  }

  connect() {
    this.totpModal = null
  }

  submitForm(event) {
    event.preventDefault()

    // Check if all required fields are filled
    const currentPassword = document.querySelector('input[name="current_password"]').value
    const newPassword = document.querySelector('input[name="admin[password]"]').value
    const confirmPassword = document.querySelector('input[name="admin[password_confirmation]"]').value

    if (!currentPassword || !newPassword || !confirmPassword) {
      alert('Please fill in all password fields.')
      return
    }

    // Check if new password and confirm password match
    if (newPassword !== confirmPassword) {
      alert('New password and confirm password do not match.')
      return
    }

    // Send request and let server decide if TOTP is required
    const formData = this.getFormData()
    this.sendRequest("/profile", "PATCH", formData, this.handleSubmitResponse.bind(this))
  }

  handleSubmitResponse(data) {
    if (data.success) {
      alert(data.message || 'Password updated successfully.')
      if (data.redirect_url) {
        window.location.href = data.redirect_url
      }
    } else {
      if (data.redirect_url) {
        window.location.href = data.redirect_url
        return
      }
      alert(data.error || 'Failed to update password.')
    }
  }

  showTotpModal(actionUrl, actionMethod, formData) {
    const event = new CustomEvent('showTotpModal', {
      detail: {
        actionUrl: actionUrl,
        actionMethod: actionMethod,
        formData: formData
      }
    })
    document.dispatchEvent(event)
  }



  sendResetPassword(event) {
    event.preventDefault()
    this.sendResetPasswordEmail()
  }

  removeAuthenticator(event) {
    event.preventDefault()
    this.removeAuthenticatorApp()
  }

  sendResetPasswordEmail() {
    this.sendRequest('/profile/reset_password', 'POST', {}, this.handleResetPasswordResponse.bind(this))
  }

  handleResetPasswordResponse(data) {
    window.location.href = data.redirect_url || '/profile/edit'
  }

  removeAuthenticatorApp() {
    this.sendRequest('/profile/disable_2fa', 'POST', {}, this.handleRemoveAuthenticatorResponse.bind(this))
  }

  handleRemoveAuthenticatorResponse(data) {
    window.location.href = data.redirect_url || '/profile/edit'
  }

  getFormData() {
    const formData = {
      admin: {
        password: document.querySelector('input[name="admin[password]"]').value,
        password_confirmation: document.querySelector('input[name="admin[password_confirmation]"]').value
      },
      current_password: document.querySelector('input[name="current_password"]').value
    }
    
    return formData
  }

  getActionUrl() {
    return this.element.action
  }

  getActionMethod() {
    return 'PATCH'
  }

  sendRequest(url, method, formData, responseHandler) {
    const csrfToken = document.querySelector('meta[name="csrf-token"]').getAttribute('content')

    fetch(url, {
      method: method,
      headers: {
        'X-CSRF-Token': csrfToken,
        'Accept': 'application/json',
        'Content-Type': 'application/json'
      },
      body: formData ? JSON.stringify(formData) : null
    })
    .then(response => response.json())
    .then(data => {
      if (data.require_totp) {
        // Show TOTP modal if server requires it
        this.showTotpModal(url, method, formData)
      } else {
        // Handle the response
        responseHandler(data)
      }
    })
    .catch(error => {
      console.error('Error:', error)
      alert('Operation failed')
    })
  }

  disconnect() {
    if (this.totpModal) {
      this.totpModal.dispose()
    }
  }
} 